/* eslint-disable max-lines */
/* eslint-disable sort-keys */
/* eslint-disable no-param-reassign */
import {
    NinchatEnvironmentConfig, NinchatEnvironmentConfigTheme,
} from 'embed/types'

import {
    embedDarkDefault, embedDefault,
} from './config.embed'

import {
    merge, pick,
} from 'lodash'

import {ThemeSchema} from 'embed/schemas'

import {zodKeys} from './../utils/schema/schema'


// themeOverrides comes from site configs and inline init script
export const overrideEmbedTheme = (colorScheme: NinchatEnvironmentConfig['colorScheme'], themeOverrides: NinchatEnvironmentConfigTheme, isWebView: boolean) => {
    // Only allow overriding variables which were defined in the schema, other parameters are ignored
    const colorAllowedOverrides = zodKeys(ThemeSchema.shape.colors)
    const pickedAllowedColorOverrides = pick(themeOverrides?.colors || {}, colorAllowedOverrides)

    // map embed theme properties to stitches properties
    // eslint-disable-next-line arrow-body-style
    const embedColorsMapped = Object.entries(pickedAllowedColorOverrides).reduce((acc, [key, value]) => {
    // buttonBackground and buttonBorder properties from embed are transformed to multiple stitches variables
        // if (key === 'buttonBackground') {
        //     acc = {
        //         ...acc,
        //         buttonBackground: value,
        //         buttonBackgroundActive: value,
        //     }
        // } else if (key === 'buttonBorder') {
        //     acc = {
        //         ...acc,
        //         buttonBorder: value,
        //         buttonBorderActive: value,
        //     }
        // }
        // else if (key === 'floatingEmbedHeader') {
        // // example when embed prameter is different than stitches property
        //     acc = {
        //         ...acc,
        //         embedHeader: value,
        //     }
        // }

        // other embed parameters are directly mapped to stitches properties
        return {
            ...acc,
            [key]: value,
        }
    }, {})


    const spaceAllowedOverrides = zodKeys(ThemeSchema.shape.space)
    const pickedSpaceOverrides = pick(themeOverrides?.space || {}, spaceAllowedOverrides)
    const embedSpaceMapped = Object.entries(pickedSpaceOverrides).reduce((acc, [key, value]) => ({
        ...acc,
        [key]: value,
    }), {})

    const zIndicesAllowedOverrides = zodKeys(ThemeSchema.shape.zIndices)
    const pickedZindicesOverrides = pick(themeOverrides?.zIndices || {}, zIndicesAllowedOverrides)
    const embedZIndicesMapped = Object.entries(pickedZindicesOverrides).reduce((acc, [key, value]) => ({
        ...acc,
        [key]: value,
    }), {})

    const radiiAllowedOverrides = zodKeys(ThemeSchema.shape.radii)
    const pickedRadiiOverrides = pick(themeOverrides?.radii || {}, radiiAllowedOverrides)
    const radiiMapped = Object.entries(pickedRadiiOverrides).reduce((acc, [key, value]) => ({
        ...acc,
        [key]: value,
    }), {})

    const fontSizesAllowedOverrides = zodKeys(ThemeSchema.shape.fontSizes)
    const pickedFontSizesOverrides = pick(themeOverrides?.fontSizes || {}, fontSizesAllowedOverrides)
    const fontSizesMapped = Object.entries(pickedFontSizesOverrides).reduce((acc, [key, value]) => ({
        ...acc,
        [key]: value,
    }), isWebView
        ? {
            embedBody: '16px',
            input: '16px',
        }
        : {})

    const fontsAllowedOverrides = zodKeys(ThemeSchema.shape.fonts)
    const pickedFontsOverrides = pick(themeOverrides?.fonts || {}, fontsAllowedOverrides)
    const fontsMapped = Object.entries(pickedFontsOverrides).reduce((acc, [key, value]) => ({
        ...acc,
        [key]: value,
    }), {})

    const fontStyleAllowedOverrides = zodKeys(ThemeSchema.shape.fontStyle)
    const pickedFontStyleOverrides = pick(themeOverrides?.fontStyle || {}, fontStyleAllowedOverrides)
    const fontStyleMapped = Object.entries(pickedFontStyleOverrides).reduce((acc, [key, value]) => ({
        ...acc,
        [key]: value,
    }), {})

    const fontVariantAllowedOverrides = zodKeys(ThemeSchema.shape.fontVariant)
    const pickedFontVariantOverrides = pick(themeOverrides?.fontVariant || {}, fontVariantAllowedOverrides)
    const fontVariantMapped = Object.entries(pickedFontVariantOverrides).reduce((acc, [key, value]) => ({
        ...acc,
        [key]: value,
    }), {})


    const shadowsAllowedOverrides = zodKeys(ThemeSchema.shape.shadows)
    const pickedShadowsOverrides = pick(themeOverrides?.shadows || {}, shadowsAllowedOverrides)
    const shadowsMapped = Object.entries(pickedShadowsOverrides).reduce((acc, [key, value]) => ({
        ...acc,
        [key]: value,
    }), {})

    const fontWeightsAllowedOverrides = zodKeys(ThemeSchema.shape.fontWeights)
    const pickedFontWeightsOverrides = pick(themeOverrides?.fontWeights || {}, fontWeightsAllowedOverrides)
    const fontWeightsMapped = Object.entries(pickedFontWeightsOverrides).reduce((acc, [key, value]) => ({
        ...acc,
        [key]: value,
    }), {})

    const borderStylesAllowedOverrides = zodKeys(ThemeSchema.shape.borderStyles)
    const pickedBorderStylesOverrides = pick(themeOverrides?.borderStyles || {}, borderStylesAllowedOverrides)
    const embedborderStylesMapped = Object.entries(pickedBorderStylesOverrides).reduce((acc, [key, value]) => ({
        ...acc,
        [key]: value,
    }), {})

    const borderWidthsAllowedOverrides = zodKeys(ThemeSchema.shape.borderWidths)
    const pickedBorderWidthsOverrides = pick(themeOverrides?.borderWidths || {}, borderWidthsAllowedOverrides)
    const embedBorderWidthsMapped = Object.entries(pickedBorderWidthsOverrides).reduce((acc, [key, value]) => ({
        ...acc,
        [key]: value,
    }), {})

    const lineHeightsAllowedOverrides = zodKeys(ThemeSchema.shape.lineHeights)
    const pickedLineHeightsOverrides = pick(themeOverrides?.lineHeights || {}, lineHeightsAllowedOverrides)
    const lineHeightsMapped = Object.entries(pickedLineHeightsOverrides).reduce((acc, [key, value]) => ({
        ...acc,
        [key]: value,
    }), {})

    const maxWidthsAllowedOverrides = zodKeys(ThemeSchema.shape.maxWidths)
    const pickedMaxWidthsOverrides = pick(themeOverrides?.maxWidths || {}, maxWidthsAllowedOverrides)
    const maxWidthsMapped = Object.entries(pickedMaxWidthsOverrides).reduce((acc, [key, value]) => ({
        ...acc,
        [key]: value,
    }), {})

    const sizesAllowedOverrides = zodKeys(ThemeSchema.shape.sizes)
    const pickedSizesOverrides = pick(themeOverrides?.sizes || {}, sizesAllowedOverrides)
    const sizesMapped = Object.entries(pickedSizesOverrides).reduce((acc, [key, value]) => ({
        ...acc,
        [key]: value,
    }), {})

    const backgroundSizesAllowedOverrides = zodKeys(ThemeSchema.shape.backgroundSizes)
    const pickedBackgroundSizesOverrides = pick(themeOverrides?.backgroundSizes || {}, backgroundSizesAllowedOverrides)
    const backgroundSizesMapped = Object.entries(pickedBackgroundSizesOverrides).reduce((acc, [key, value]) => ({
        ...acc,
        [key]: value,
    }), {})

    return merge({}, colorScheme === 'dark' ? embedDarkDefault : embedDefault, {
        borderStyles: embedborderStylesMapped,
        borderWidths: embedBorderWidthsMapped,
        colors: embedColorsMapped,
        space: embedSpaceMapped,
        zIndices: embedZIndicesMapped,
        radii: radiiMapped,
        fontSizes: fontSizesMapped,
        fonts: fontsMapped,
        fontStyle: fontStyleMapped,
        fontVariant: fontVariantMapped,
        fontWeights: fontWeightsMapped,
        shadows: shadowsMapped,
        lineHeights: lineHeightsMapped,
        maxWidths: maxWidthsMapped,
        backgroundSizes: backgroundSizesMapped,
        sizes: sizesMapped,
    })
}
